// extracted by mini-css-extract-plugin
export default {"leftSection":"LeftSection_leftSection__teauG"};